import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import NewsLetterStore from '../../stores/NewsLetterStore';
import NewsLetterActions from '../../actions/NewsLettersActions';
import {connectToStores} from 'epic-alt-utils/index';

@connectToStores
class NewsLetter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: this._openModal.bind(this),
            email: props.email
        };
    }

    static getStores() {
        return [NewsLetterStore];
    }

    static getPropsFromStores() {
        return {
            newsLetterStore: NewsLetterStore.getState()
        };
    }

    static propTypes = {
        isLoggedIn: PropTypes.bool,
        email: PropTypes.string,
        newsLetterConfigs: PropTypes.object,
        newsLetterStore: PropTypes.object
    };

    inputOnChange = (e) => {
        this.setState({
            email: e.target.value
        });
    }

    _openModal(e) {
        e.preventDefault();
        this.setState({
            isOpen: true
        });
    }

    handleAfterOpenFunc = () => {
        if (this.props.isLoggedIn && !this.props.newsLetterStore.checked) {
            // try get email status first
            const email = this.state.email;
            NewsLetterActions.getSubscriptionStatus.defer({email});
        }
    }

    handleRequestCloseFunc = () => {
        this.setState({
            isOpen: false
        });
    }

    submit = () => {
        const email = this.state.email;
        NewsLetterActions.signUpNewsLetter.defer({email});
    }

    render() {
        const store = this.props.newsLetterStore;
        const loading = store.loading;
        const success = store.success;
        const errorMsg = store.errorMsg;
        const hasSubscribed = store.hasSubscribed;
        const config = this.props.newsLetterConfigs;
        const unsubLink = config.unsubLink && this.state.email ? `${config.unsubLink}?email=${this.state.email}` : null;
        const style = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.75)',
                zIndex: 99
            },
            content: {
                position: 'relative',
                top: '50%',
                transform: 'translateY(-50%)',
                margin: '0 auto',
                padding: '60px 50px 40px',
                borderRadius: '1px',
                verticalAlign: 'middle',
                backgroundColor: '#fff',
                boxShadow: '0 0 20px 0 rgba(50,50,50,.6)',
                maxWidth: '460px',
                minHeight: '370px',
                width: '100%'
            }
        };
        const defaultView = (
            <div className="defaultView">
                <div className="newsletter-form">
                    <h1 className="signup-title">{config.titleMsg}</h1>
                    <li className="sign-up-form-field">
                        <label htmlFor="signUpEmail" className="email-label">Email</label>
                        <input id="signUpEmail" className="input-field" value={this.state.email} onChange={this.inputOnChange} />
                    </li>
                    {errorMsg ? <p>{errorMsg}</p> : null}
                    <button id="sign-up-button" className="btn modal-btn" onClick={this.submit}>{config.btnTxt}</button>
                </div>
            </div>);

        const successView = (
            <div className="successView">
                <h2>{config.successMsg}</h2>
                {unsubLink ? <a id="unsubscribe-button" className="btn modal-btn" href={unsubLink} target="_blank">{config.unsubText}</a> : null}
            </div>
        );

        const loadingView = (<div className="loading" />);
        const hasSubscribedView = (
            <div className="alreadySubscribed">
                <h2>{config.alreadySubscribedMsg}</h2>
                {unsubLink ? <a id="unsubscribe-button" className="btn modal-btn" href={unsubLink} target="_blank">{config.unsubText}</a> : null}
            </div>
        );
        let view;

        if (loading) {
            view = loadingView;
        } else if (hasSubscribed && !errorMsg) {
            view = hasSubscribedView;
        } else if (success) {
            view = successView;
        } else {
            view = defaultView;
        }

        return (
            <div className="col-xs-12 col-sm-4 col-md-5 col-lg-6">
                <div className="footer-cta-btn">
                    <a href="" onClick={this.state.openModal} className="accent-bg-color accent-bg-color-hover">
                        <span className="accent-text-color accent-text-color-hover">{config.titleMsg}</span>
                    </a>
                </div>
                <ReactModal
                    contentLabel="NewsLetter"
                    portalClassName="footer-news-letter-modal"
                    overlayClassName="news-letter-overlay"
                    className="footer-news-letter-content"
                    bodyOpenClassName="news-letter-modal-opened"
                    style={style}
                    isOpen={this.state.isOpen}
                    onAfterOpen={this.handleAfterOpenFunc}
                    onRequestClose={this.handleRequestCloseFunc}
                    shouldCloseOnOverlayClick={true} >
                    <button className="close-btn" onClick={this.handleRequestCloseFunc}>
                        <span className="close icon-cross" />
                    </button>
                    <img className="newsletter-logo" src={config.logo} alt="logo" />
                    {view}
                </ReactModal>
            </div>
        );
    }
}

export default NewsLetter;



// WEBPACK FOOTER //
// ./app/scripts/components/newsLetter/NewsLetter.js